import { FC } from 'react';
import ProCard, { CardProps } from './card';
import ProCardGrid, { CardGridProps } from './grid';
import ProCardMeta, { CardMetaProps } from './meta';

export type ICardComponent = FC<CardProps> & {
  Grid: FC<CardGridProps>;
  Meta: FC<CardMetaProps>;
};

const TransCard = ProCard as ICardComponent;
TransCard.Grid = ProCardGrid;
TransCard.Meta = ProCardMeta;

export default TransCard;
